import React, { Component } from "react";
import { getOrderHistoryList, getOrderHistoryView } from "../../Api.js";
import OrderHistoryView from "../Widgets/OrderHistoryView/OrderHistoryView";
import OrderHistoryListViewSkeleton from "../Widgets/Loading/OrderHistoryListView";
import OrderDetailsSkeleton from "../Widgets/Loading/OrderDetails";
// import Lottie from "react-lottie";
import T from "i18n-react";
import withConsumerAuth from "../Auth/WithConsumerAuth";
import Button from "../Widgets/Button";
// import animationData from "../../lottie/loading.json";
import { LOGIN } from "../../constants/URL.const";
import { ReactComponent as BagSVG } from "../../imges/Bag_new.svg";
import { ReactComponent as BackArrowSVG } from "../../imges/ArrowLeft.svg";
import Styles from "./settingPage.module.scss";
import SettingsPageList from "./SettingsPageList";
import { ISettingPageProps, ISettingPageState } from "./types.d";
class SettingsPage extends Component<ISettingPageProps, ISettingPageState> {
  state = {
    stage: 1,
    pageTitle: "Order History",
    selectedOrder: false,
    ordersList: [],
    orderInfo: null,
    gotData: false,
    error: [],
  };

  componentWillMount() {
    this.onComponentMountFlow().catch((e) => {
      if (e.response) {
        if (e.response.status === 400) {
          this.setState({
            error: [e.response.data.message],
          });
        } else if (e.response.status === 404) {
          this.setState({
            error: [e.response.data.message],
          });
        } else if (e.response.status === 403) {
          this.setState({
            error: [e.response.data.message],
          });
        } else if (e.response.status === 401) {
          // localStorage.clear()
          window.localStorage.removeItem("user_token");
          this.props.history.push(LOGIN);
        } else if (e.response.status === 422) {
          this.setState({
            error:
              e.response.data.errors[Object.keys(e.response.data.errors)[0]],
          });
        } else {
          window.localStorage.removeItem("user_token");
          this.props.history.push(LOGIN);
        }
      }
    });
  }
  onComponentMountFlow = async () => {
    const token = await this.props
      .retrieveToken()
      .catch((e) => localStorage.removeItem("user_token"));
    const orderList = await getOrderHistoryList(token);
    this.setState({
      ordersList: orderList.data.data,
      gotData: true,
    });
  };

  getInfo = async (id) => {
    this.setState({
      orderInfo: null,
    });
    const token = await this.props.retrieveToken();

    getOrderHistoryView(token, id)
      .then((res) => {
        this.setState({
          orderInfo: res.data.data,
        });
      })
      .catch((e) => {
        if (e.response) {
          if (e.response.status === 400) {
            this.setState({
              error: [e.response.data.message],
            });
          } else if (e.response.status === 404) {
            this.setState({
              error: [e.response.data.message],
            });
          } else if (e.response.status === 403) {
            this.setState({
              error: [e.response.data.message],
            });
          } else if (e.response.status === 401) {
            // localStorage.clear()
            window.localStorage.removeItem("user_token");
            this.props.history.push(LOGIN);
          } else if (e.response.status === 422) {
            this.setState({
              error:
                e.response.data.errors[Object.keys(e.response.data.errors)[0]],
            });
          } else
            this.setState({
              error: [e.response.data.message],
            });
        }
      });
  };
  getLogo = () => {
    if (this.state.orderInfo) {
      const order = this.state.ordersList.find(
        (order) => order.id === this.state.orderInfo.placed_order_id
      );
      return order.url_logo;
    } else return null;
  };

  render() {
    return (
      <div
        className={Styles.settingsPageContainer}
        id={"settingsPageContainerId"}
      >
        <div className={Styles.header}>
          <div className={Styles.pageTitle}>
            <BagSVG />
            <T.p
              className="HeaderTitle"
              text={{ key: `OrderHistory.OrderHistory` }}
            />
          </div>
          <Button
            isHeaderBtn
            className={Styles.backBtn}
            Icon={<BackArrowSVG />}
            onClick={() => {
              if (this.state.selectedOrder) {
                this.setState({
                  selectedOrder: false,
                });
              } else {
                this.props.closeSettingsPage();
              }
            }}
          />
        </div>
        {!this.state.gotData ? (
          <OrderHistoryListViewSkeleton />
        ) : this.state.selectedOrder ? (
          !this.state.orderInfo ? (
            <OrderDetailsSkeleton />
          ) : (
            <OrderHistoryView
              info={this.state.orderInfo}
              venueLogo={this.getLogo()}
            />
          )
        ) : (
          <div className={Styles.orderList} id={"ordersListId"}>
            <SettingsPageList
              orderHistoryItems={this.state.ordersList}
              onSelectedOrderItem={(orderId) => {
                this.getInfo(orderId);
                this.setState({
                  selectedOrder: true,
                });
              }}
            />
          </div>
        )}
      </div>
    );
  }
}
export default withConsumerAuth(SettingsPage);
